"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("./constants/enums");

var _errorHandler;

var _platform = enums_1.EnumPlatform.NA;

function setErrorHandler(cb) {
  _errorHandler = cb;
}

exports.setErrorHandler = setErrorHandler;

function triggerErrorHandler(error) {
  if (_errorHandler) {
    _errorHandler(error);
  }
}

exports.triggerErrorHandler = triggerErrorHandler;

function setPlatform(platform) {
  _platform = platform;
}

exports.setPlatform = setPlatform;

function setPlatformAsApp() {
  _platform = enums_1.EnumPlatform.APP;
}

exports.setPlatformAsApp = setPlatformAsApp;

function setPlatformAsWeb() {
  _platform = enums_1.EnumPlatform.WEB;
}

exports.setPlatformAsWeb = setPlatformAsWeb;

function getPlatform() {
  return _platform;
}

exports.getPlatform = getPlatform;

function checkIfPlatformIsApp() {
  return getPlatform() === enums_1.EnumPlatform.APP;
}

exports.checkIfPlatformIsApp = checkIfPlatformIsApp;